<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Partner Branch</div>
        <div>
          <bread-crumb :bread-crumbs="['Partner Summary', 'Partner Branch']" />
        </div>
      </v-card-title>

      <v-data-table fixed-header  height="55vh" :headers="dessertHeaders" :items="desserts" item-key="name">
        <template v-slot:item.BranchID="{ item }">
          <a
            class="text-decoration-underline"
            @click="BranchID()"
            :title="item.BranchID"
          >
            {{ item.BranchID }}
          </a>
        </template>
        <template v-slot:item.Details="{ item }">
          <a
            class="text-decoration-underline"
            @click="userDetail()"
            :title="item.Userdetail"
          >
            {{ item.Details }}
          </a>
        </template>

        <template v-slot:item.is_active="{ item }">
          <div class="d-flex">
            <v-switch
              v-model="item.is_active"
              height="0px"
              color="success"
              dense
            ></v-switch>
            <v-icon small color="primary" class="mr-2" @click="editItem(item)">
              mdi-trash-can-outline
            </v-icon>
          </div>
        </template>

        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>

          <v-row class="mt-3">
            <v-col cols="12">
              <v-btn depressed 
                small
                color="primary"
                to="/partner-setup/summary/newBranch"
                class="text-decoration-none text-capitalize ms-3"
                >New</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col></v-col>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Search"
                hide-details
                class="me-4"
                dense
                clearable
              ></v-text-field
            ></v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name:"",
  data() {
    return {
      search: "Partner Branch",
      dessertHeaders: [
        {
          text: "SNo",
          align: "start",
          sortable: false,
          value: "SNo",
        },
        { text: "Branch ID", value: "BranchID" },
        { text: "Access Code", value: "AccessCode" },
        { text: "Name", value: "Name" },
        { text: "Telephone", value: "Telephone" },
        { text: "City", value: "City" },
        { text: "Ext.Branch Code", value: "ExtBranchCode" },
        { text: "Details", value: "Details" },
        { text: "Actions", value: "is_active" },
      ],
      desserts: [
        {
          SNo: "1",
          BranchID: "10000006",
          AccessCode: "AGRANI",
          Name: "Main branch",
          Telephone: "",
          City: "",
          ExtBranchCode: "",
          Details: "User detail",
        },
      ],
      BranchID() {
        this.$router.push({ name: "Edit Branch" });
      },
      userDetail() {
        this.$router.push({ name: "User Detail" });
      },
    };
  },
  components: {
    BreadCrumb,
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
